import { AvatarQuotaResponse } from "@/interfaces/nftTypes";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import OpenAccountModal from "../common/OpenAccountModal";
import { useState } from "react";
import handleDeepLink from "@/utils/handleDeepLink";
import clientDeepLinks from "@/utils/clientDeepLinks";
import { useMasterAccount } from "@/hooks/useRequest/useSurveyRequest";
import { DepositQuestionsAuditStatus, MasterAccountOpenStatus } from "@/interfaces/enums";
import { BackIcon } from "@/components/RFIcon";

type NTFDepositProps = Omit<AvatarQuotaResponse, "depositAmount" | "depositCurrency" | "hasOwned"> & {
	depositAmount?: number;
	depositCurrency?: string;
	hasOwned?: boolean;
	loading?: boolean;
};

export default function NTFDeposit(props?: NTFDepositProps) {
	const router = useRouter();
	const [visible, setVisible] = useState(false);
	const { masterAccount } = useMasterAccount();

	const { t } = useTranslation("nft");
	const handleDirectDeposit = () => {
		// 未开户
		if (Number(masterAccount?.masterAccountOpenStatus) < MasterAccountOpenStatus.APPROVED) {
			setVisible(true);
		} else if (
			// 未提交入金问卷
			Number(masterAccount?.depositQuestionsAuditStatus) < DepositQuestionsAuditStatus.SUBMITTED
		) {
			handleDeepLink(clientDeepLinks.depositQuestionsAnswer());
		} else {
			router.push("/deposit");
		}
	};

	const renderOwnAvatarDesc = () => {
		if (props?.loading) {
			return "";
		}
		if (props?.hasOwned) {
			return t("avatar-claimed");
		}
		if (props?.canOwned) {
			return t("x-star-avatars-available", {
				star: props.canOwnedTopStarLevel,
			});
		}
		return t("your-deposit-is-less-than-no-avatar-available");
	};

	return (
		<>
			<div
				className="bg-f3f1f dark:bg-black_18 p-4 flex items-start text-sm font-normal link-text"
				onClick={handleDirectDeposit}
			>
				<div className="flex-1 mr-4" dangerouslySetInnerHTML={{ __html: renderOwnAvatarDesc() }} />
				<div className="flex-shrink-0 flex items-center font-semibold">
					<span>{t("nft-deposit-now")}</span>
					<span className="ml-1" style={{ transform: "rotate(180deg)" }}>
						<BackIcon className="w-3.5 h-3.5" strokeWidth={2} />
					</span>
				</div>
			</div>

			<OpenAccountModal
				visible={visible}
				onClose={() => setVisible(false)}
				onConfirm={() => {
					setVisible(false);
					handleDeepLink(clientDeepLinks.assetPage());
				}}
			/>
		</>
	);
}
